import MultipleChoiceClosedQuestion from 'models/common/form/question/MultipleChoiceClosedQuestion';

import ClosedQuestionService from 'services/common/form/question/ClosedQuestionService';

export default class MultipleChoiceClosedQuestionService extends ClosedQuestionService {
	toModel(question) {
		return new MultipleChoiceClosedQuestion(super.toModel(question));
	}
}
